import get from 'lodash.get';

const getCustomColorPalettes = (state) =>
  get(state, 'ws.site.meta.customization.customColorPalettes', []);

export default getCustomColorPalettes;
